<div class="container">
  <h3 class="widget-header">Twilio Flex CTI Widget</h3>
  <div class="widget-content">
    <span class="login-info">Logged in Employee Number <span class="employee-id">{{this.employeeId || ''}}</span></span>
  </div>
  <div class="status-indicator">
    <span>Status: </span>
    @if (errorMessage) {
    <div class="widget-error">
      <span class="status-error">ERROR - Something goes wrong!
        <span class="error-message">{{errorMessage.message}}</span>
      </span>
    </div>
    } @else {
    <span class="status-ok">OK</span>
    }
  </div>

</div>